import MemberWarningType from '@vestahealthcare/common/models/member-warnings/MemberWarningType';

import Api from 'dash/src/services/Api';

export const fetchAvailableWarnings = async (): Promise<
  MemberWarningType[]
> => {
  const { warningTypes } = await Api.getv2('/warnings/types');
  return warningTypes.items
    .map((type: any) => new MemberWarningType(type))
    .filter(MemberWarningType.filterHiddenType);
};
